import { pluginApi } from 'services/api';

export default async (uuid: string): Promise<void> => {
  await pluginApi.post('/strategy-plans/ask-approvation', { uuid });
};
